import React, { useRef, useState, useEffect } from "react";
import "./VerifyCommunityDetail.css";
import UploadFile from "../../../../assets/images/UploadFile.svg";
import editIcon from "../../../../assets/images/edit.svg";
import CopyIcon from "../../../../assets/images/Copy.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { toastify } from "../../../../helpers/toast/toastify";
import {
  setRefetchMultiCommunityList,
  setRefetchSpecificUser,
  setRefetchPage,
} from "../../../../redux/multicommunity/multicommunity";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

const config = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const VerifyCommunityDetail = () => {
  const api = useApi();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [communityName, setCommunityName] = useState("");
  const [editableField, setEditableField] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [communityLogo, setCommunityLogo] = useState("");
  const [showCropper, setShowCropper] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [cropper, setCropper] = useState(null);

  const selectedCommunity = useSelector(
    (state) => state?.multiCommunity?.currentCommunity
  );

  const inputRefs = useRef({});

  const handleEditClick = (fieldId) => {
    setEditableField(fieldId);

    setTimeout(() => {
      if (inputRefs.current[fieldId]) inputRefs.current[fieldId].focus();
    }, 100);
  };

  useEffect(() => {
    if (selectedCommunity) {
      setCommunityName(selectedCommunity?.disPlayName);
      setCommunityLogo(selectedCommunity?.logo || "");
    }
  }, [selectedCommunity]);

  const handleSave = async () => {
    try {
      if (selectedCommunity?.disPlayName !== communityName) {
        if (!communityName) {
          toastify("Community required");
          return;
        }
        if (communityName?.length > 30) {
          toastify("Community Name must not be greated than 30 character");
          return;
        }

        const response = await api(
          "post",
          "multiCommunity/updateCommunityName",
          {
            communityName: communityName,
          }
        );

        if (response?.status) {
          setEditableField(null);
    
          dispatch(setRefetchMultiCommunityList(true));
          dispatch(setRefetchPage("Settings"));
          toastify("Community name is changed", "success");
          setShowButton(false);
        } else {
          setEditableField(null);
          toastify(response?.message, "error");
        }
      } else {
        setEditableField(null);
        setShowButton(false);
        toastify("please change community name", "error");
      }
    } catch (error) {
      toastify(error?.message, "error");
      setShowButton(false);
      setEditableField(null);
    }
  };

  const updateCommunityLogo = async (logoUrl, fileName) => {
    try {
      const response = await api("post", "community/updateCommunityLogo", {
        communityId: selectedCommunity?._id,
        logo: logoUrl,
      });

      if (response?.status) {
        setCommunityLogo(logoUrl);
        setFileName(fileName);
        toastify("Community logo updated successfully", "success");

        // Trigger refetch to update the community data
        dispatch(setRefetchSpecificUser(true));
        dispatch(setRefetchMultiCommunityList(true));
        dispatch(setRefetchPage("Settings"));
      } else {
        toastify("Failed to update community logo. Please try again.", "error");
      }
    } catch (error) {
      console.error("Logo update error:", error);
      toastify("Failed to update community logo. Please try again.", "error");
    }
  };

  const uploadCroppedFile = async (croppedBlob, fileName) => {
    try {
      let fd = new FormData();
      fd.append("file", croppedBlob, fileName);
      let response = await config.post("community/uploadFile", fd);
      let url = response?.data?.data;
      if (url) {
        await updateCommunityLogo(url, fileName);
      } else {
        toastify("Unable to upload image. Please contact support.", "error");
      }
    } catch (error) {
      toastify("Failed to upload image. Please try again.", "error");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      if (!allowedTypes.includes(file.type)) {
        toastify("Please select a valid image file (JPEG, PNG, GIF)", "error");
        event.target.value = ""; // Reset input
        return;
      }
      // Validate file size (5MB limit)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        toastify("File size must be less than 5MB", "error");
        event.target.value = ""; // Reset input
        return;
      }
      // Read file as data URL for cropper
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
    // Always reset input so the same file can be selected again
    event.target.value = "";
  };

  const handleCropSave = async () => {
    if (cropper) {
      cropper.getCroppedCanvas().toBlob(async (blob) => {
        if (blob) {
          setShowCropper(false);
          setImageSrc(null);
          await uploadCroppedFile(blob, fileName || "cropped_image.png");
        }
      }, "image/png");
    }
  };

  const handleCropCancel = () => {
    setShowCropper(false);
    setImageSrc(null);
    setFileName("");
  };

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <div className="VerifyCommunityDetailBox">
        <div className="headingBox">
          <h2 className="title">Community Details</h2>
        </div>
        <div className="InputsRow">
          <div className="editable-field fixedWidth1440-298">
            <FloatingTextFiled
              className="accdetailinputbox"
              forLabel="community-name"
              id="community-name"
              label="Community Name"
              placeholder="Community Name"
              type="text"
              value={communityName}
              ref={(el) => (inputRefs.current["communityName"] = el)}
              disabled={editableField !== "communityName"}
              onChange={(e) => {
                setShowButton(true);
                setCommunityName(e.target.value);
              }}
              focusedAllowed={false}
              maxLength={30}
            />
            <span
              className="edit-icon"
              style={{ cursor: "pointer", marginLeft: "10px" }}
              onClick={() => handleEditClick("communityName")}
            >
              <img alt="Edit Icon" src={editIcon} />
            </span>
          </div>
          <div className="editable-field fixedWidth1440-298">
            <FloatingTextFiled
              className="accdetailinputbox pdr20"
              forLabel="community-name"
              id="community-name"
              label="Copy Trading URL"
              placeholder="Copy Trading URL"
              type="text"
              disabled={true}
              focusedAllowed={false}
              value={`${document.location.origin.replace(
                document.location.pathname,
                ""
              )}/community/${selectedCommunity?.name?.split(" ").join("")}`}
            />
            <span
              className="edit-icon"
              style={{ cursor: "pointer", marginLeft: "10px" }}
            >
              <img
                alt="Copy Icon"
                src={CopyIcon}
                onClick={() => {
                  // Construct the community link using template literals
                  const communityLink = `${document.location.origin.replace(
                    document.location.pathname,
                    ""
                  )}/community/${selectedCommunity?.name?.split(" ").join("")}`;

                  // Attempt to copy the link to the clipboard
                  navigator.clipboard
                    .writeText(communityLink)
                    .then(() => {
                      // Success: Show a toast notification
                      toastify(
                        "Community link copied to clipboard!",
                        "success"
                      );
                    })
                    .catch((error) => {
                      // Error: Handle clipboard write failure and show a toast notification
                      console.error("Clipboard write error:", error);
                      toastify(
                        "Failed to copy community link to clipboard.",
                        "error"
                      );
                    });
                }}
                style={{ width: "19px", height: "19px" }}
              />
            </span>
          </div>

          <div
            className="editable-field fixedWidth1440-298 DisableIconOvercome"
            style={{ display: "flex", alignItems: "center" }}
            onClick={handleIconClick}
          >
            <div className="accdetailinputbox DisableOvercome uploadFileInputWrap">
              <p className="uplaodFileText">
                {fileName
                  ? fileName
                  : `${
                      communityLogo ? "Change" : "Upload"
                    }  community photo (logo)`}
              </p>
            </div>
            <span
              className="edit-icon UploadFileImg"
              style={{ cursor: "pointer", marginLeft: "10px" }}
            >
              <img alt="Upload Icon" src={UploadFile} />
            </span>

            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/jpeg,image/jpg,image/png,image/gif"
              style={{ display: "none" }}
            />
          </div>
        </div>

        {showButton && (
          <div className="submitbtn ms-lg-auto ms-md-auto">
            <BubbleSvgButton
              onClick={handleSave}
              text={"Save edits"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
                padding: 0,
              }}
              mainDivStyle={{
                width: "215px",
                height: "55px",
              }}
            />
          </div>
        )}
      </div>

      {/* Cropper Modal */}
      <Modal show={showCropper} centered>
        <Modal.Header>
          {/* <Modal.Title>{`Upload ${communityName} Logo`}</Modal.Title> */}
          <Modal.Title>{`Add profile photo / logo`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {imageSrc && (
            <Cropper
              style={{ height: 300, width: "100%" }}
              src={imageSrc}
              viewMode={1}
              guides={true}
              minCropBoxHeight={100}
              minCropBoxWidth={100}
              background={false}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false}
              onInitialized={(instance) => setCropper(instance)}
            />
          )}
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center" }}>
          <BubbleSvgButton
            className="imageCropButtons"
            text="Cancel"
            variant="black"
            onClick={handleCropCancel}
            mainDivStyle={{ width: "120px", height: "40px" }}
            containerStyling={{
              justifyContent: "center",
              padding: 0,
            }}
          />
          <BubbleSvgButton
            className="imageCropButtons"
            text="Save Crop"
            variant="green"
            onClick={handleCropSave}
            mainDivStyle={{ width: "120px", height: "40px" }}
            containerStyling={{
              justifyContent: "center",
              padding: 0,
            }}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VerifyCommunityDetail;
